import React from 'react';
import { AirPlay } from '@finect/tabular-icons/airPlay';
import { Sliders } from '@finect/tabular-icons/sliders';
import { List } from '@finect/tabular-icons/list';
import { BarChart } from '@finect/tabular-icons/barChart';
import { ExpandContainer } from './partials';
var icons = {
  airPlay: AirPlay,
  sliders: Sliders,
  list: List,
  chart: BarChart
};
export var SectionAction = function SectionAction(_ref) {
  var onClick = _ref.onClick,
    actionText = _ref.actionText,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? 'airPlay' : _ref$icon;
  var Icon = icons[icon];
  return React.createElement(ExpandContainer, {
    onClick: onClick
  }, React.createElement(Icon, {
    size: "15",
    strokeWidth: "2.5"
  }), actionText);
};